<div class="tools-container" [formGroup]="toolsFormGroup">
  <h4 class="tools-title">{{ 'PRESENTER.POWER_PLEDGE_TOOLS.TITLE' | translate }}</h4>

  <gb-token-color-picker
    circleDiameter="38px"
    [control]="tablePrimaryColorControl"
    labelTranslateKey="PRESENTER.POWER_PLEDGE_TOOLS.PRIMARY_COLOR"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>

  <gb-token-color-picker
    circleDiameter="38px"
    [control]="tableAccentColorControl"
    labelTranslateKey="PRESENTER.POWER_PLEDGE_TOOLS.ACCENT_COLOR"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>

  <gb-presenter-tools-advanced-options-container>
    <div class="tools-row">
      <mat-form-field>
        <mat-label>{{ 'PRESENTER.POWER_PLEDGE_TOOLS.ROWS' | translate }}</mat-label>
        <input matInput type="number" [formControl]="rowsControl" min="1" max="20" />
      </mat-form-field>
    </div>

    <h4 class="tools-title">{{ 'PRESENTER.POWER_PLEDGE_TOOLS.RANK_COLORS_TITLE' | translate }}</h4>

    <gb-token-color-picker
      circleDiameter="38px"
      [control]="firstPlaceColorControl"
      labelTranslateKey="PRESENTER.POWER_PLEDGE_TOOLS.FIRST_PLACE_COLOR"
      cpPosition="right"
      [showDropdown]="true"
    ></gb-token-color-picker>

    <gb-token-color-picker
      circleDiameter="38px"
      [control]="secondPlaceColorControl"
      labelTranslateKey="PRESENTER.POWER_PLEDGE_TOOLS.SECOND_PLACE_COLOR"
      cpPosition="right"
      [showDropdown]="true"
    ></gb-token-color-picker>

    <gb-token-color-picker
      circleDiameter="38px"
      [control]="thirdPlaceColorControl"
      labelTranslateKey="PRESENTER.POWER_PLEDGE_TOOLS.THIRD_PLACE_COLOR"
      cpPosition="right"
      [showDropdown]="true"
    ></gb-token-color-picker>

    <gb-token-color-picker
      circleDiameter="38px"
      [control]="defaultRankColorControl"
      labelTranslateKey="PRESENTER.POWER_PLEDGE_TOOLS.DEFAULT_RANK_COLOR"
      cpPosition="right"
      [showDropdown]="true"
    ></gb-token-color-picker>

    <div class="opacity-slider-container">
      <label class="opacity-label">{{ 'PRESENTER.POWER_PLEDGE_TOOLS.OPACITY' | translate }}</label>
      <div class="slider-wrapper">
        <mat-slider min="0" max="1" step="0.01" discrete>
          <input matSliderThumb [formControl]="opacityControl" />
        </mat-slider>
        <span class="opacity-value">{{ opacityControl.value }}</span>
      </div>
    </div>

    <gb-presenter-tools-text [toolsFormGroup]="toolsFormGroup" [hideFields]="hideFields"></gb-presenter-tools-text>
  </gb-presenter-tools-advanced-options-container>
</div>
